<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Вы исключены из отдела {{ item.info.departmentName }} компании
    a(:href="$router.resolve({ name: 'company-detail', params: { companyId: item.info.companyId } }).href")  {{ item.info.companyName }}
</template>

<script>
export default {
  name: 'NotificationCompanyDepartmentMemberDeleted',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
